(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response')
    .factory(
      'FreeTextResponseResultExportCsv', 
      FreeTextResponseResultExportCsv
    );
      
    FreeTextResponseResultExportCsv.$inject = [
    '$log', 
    '$filter', 
    '$q', 
    'csvWriter'
  ];
    
  function FreeTextResponseResultExportCsv(
      $log, 
      $filter, 
      $q, 
      csvWriter) {
    $log = $log.getInstance('FreeTextResponseResultExportCsv');
    
    return {
      canExportResult: canExportResult,
      exportResults: exportResults
    };
    
    function canExportResult(result) {
      return result.type === 'free-text-response';
    }
    
    function exportResults(results) {
      $log.debug('results = ', results);
      var csv = csvWriter();
      var resultsByPoll = groupResultsByPoll(results);
      _.each(resultsByPoll, function(pollResults, pollId) {
        var group = _.first(pollResults).group;
        var poll = _.first(pollResults).poll;
        var responses = _.flatten(_.pluck(pollResults, 'responses'));
        addHeaderForPoll(csv, group, poll);
        addResponsesForPoll(csv, responses);
      });
      return $q.resolve(csv.blob());
    }
    
    function addHeaderForPoll(csv, group, poll) {
      csv
        .addRow(['Group:', group.name])
    }
    
    function addResponsesForPoll(csv, responses) {
      csv.addRow(['First Name', 'Last Name', 'Username', 'Email', 'Timestamp', 'Response']);
      console.log(responses)
      responses.forEach(function(response){
        csv.addRow([
          response.user.name.first,
          response.user.name.last,
          response.user.username,
          response.user.email, 
          $filter('date')(response.time, 'yyyy-MM-dd HH:mm:ss'), 
          response.data.textResponse,
        ]);
      })
      csv.newRow();
    }
    
    function groupResultsByPoll(results) {
      return _.groupBy(results, function(result) {
        return result.poll._id;
      });
    }
  }
  
})();
